import { FC } from "react";
import { Box, CircularProgress, Divider, TextField } from "@mui/material";
import MailTwoToneIcon from "@mui/icons-material/MailTwoTone";
import useContacto from "./useContacto";

const capitalizar = (texto: string) =>
  texto ? texto.charAt(0).toUpperCase() + texto.slice(1) : texto;

const Contacto: FC = () => {
  const { contactos, isLoading, savingId, setCorreo, guardarCorreo, tieneCambios } = useContacto();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        marginTop: "50px",
      }}
    >
      <h1>CONTACTO</h1>

      <div className="contenedor">
        <h2 className="titSeccion">Contacto</h2>

        {isLoading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {!isLoading &&
          contactos.map((contacto, index) => (
            <Box key={contacto.id}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  py: 2,
                }}
              >
                <MailTwoToneIcon sx={{ color: "#626262", fontSize: 28 }} />

                <Box sx={{ flexGrow: 1 }}>
                  <p
                    className="espacio"
                    style={{ margin: 0, marginBottom: 4 }}
                  >
                    {capitalizar(contacto.categoria)}
                  </p>

                  <TextField
                    variant="outlined"
                    type="email"
                    value={contacto.correo}
                    onChange={(e) => setCorreo(contacto.id, e.target.value)}
                    fullWidth
                    size="small"
                    style={{ background: "#fff" }}
                  />
                </Box>

                <input
                  type="button"
                  value={savingId === contacto.id ? "Guardando..." : "Guardar"}
                  className="btnAceptar"
                  disabled={!tieneCambios(contacto.id) || savingId === contacto.id}
                  onClick={() => guardarCorreo(contacto.id)}
                  style={{
                    opacity: !tieneCambios(contacto.id) || savingId === contacto.id ? 0.4 : 1,
                    cursor: !tieneCambios(contacto.id) || savingId === contacto.id ? "not-allowed" : "pointer",
                    whiteSpace: "nowrap",
                  }}
                />
              </Box>

              {index < contactos.length - 1 && <Divider />}
            </Box>
          ))}
      </div>
    </div>
  );
};

export default Contacto;
